import { makeStyles } from "@material-ui/core/styles";
import { FormControlLabel, Radio, RadioGroup, Switch } from "@material-ui/core";
import { useCallback, useState } from "react";
import {
  SATELLITE_TYPE_IRHT,
  SATELLITE_TYPE_IRHT_COLOR, SATELLITE_TYPE_IRTP, SATELLITE_TYPE_IRTP_COLOR,
  SATELLITE_TYPE_WV
} from "../layers/Satellite";
import { useMapColorState } from "../../../store/MapColorState";
import { weatherTimeWithID, WX_ID_SATELLITE } from "../../../store/WeatherContentsState";
import { useRecoilValue } from "recoil";

const useStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent: 'flex-start'
  },
  inputLabel: {
    fontSize:"12px"
  },

  satelliteLegend: {
    height: "80px",
    padding: "0",
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    '&>li': {
      position: 'relative',
      lineHeight: '30px',
      height: '20px',
      paddingLeft: '30px',
      textAlign: 'left'
    }
  },
  satelliteIrhtColorGt450ft:{'&:after': {background: 'rgba(212, 0, 0, 0.6)'}},
  satelliteIrhtColorGt400ft:{'&:after': {background: 'rgba(223, 102, 102, 0.6)'}},
  satelliteIrhtColorGt350ft:{'&:after': {background: 'rgba(255, 255, 0, 0.6)'}},
  satelliteIrhtColorGt300ft:{'&:after': {background: 'rgba(193, 210, 87, 0.6)'}},
  satelliteIrhtColorGt200ft:{'&:after': {background: 'rgba(128, 128, 128, 0.84)'}},
  satelliteIrhtColorGt100ft:{'&:after': {background: 'rgba(128, 128, 128, 0.66)'}},
  satelliteIrhtGt500ft :{'&:after':{background: 'rgba(255,255,255, 0.99)'}},

  satelliteIrhtGt450ft :{'&:after':{background: 'rgba(255,255,255, 0.98)'}},
  satelliteIrhtGt400ft :{'&:after':{background: 'rgba(255,255,255, 0.976)'}},
  satelliteIrhtGt350ft :{'&:after':{background: 'rgba(255,255,255, 0.976)'}},
  satelliteIrhtGt300ft :{'&:after':{background: 'rgba(255,255,255, 0.859)'}},
  satelliteIrhtGt250ft :{'&:after':{background: 'rgba(255,255,255, 0.725)'}},
  satelliteIrhtGt200ft :{'&:after':{background: 'rgba(255,255,255, 0.612)'}},
  satelliteIrhtGt175ft :{'&:after':{background: 'rgba(255,255,255, 0.478)'}},
  satelliteIrhtGt150ft :{'&:after':{background: 'rgba(255,255,255, 0.416)'}},
  satelliteIrhtGt125ft :{'&:after':{background: 'rgba(255,255,255, 0.361)'}},
  satelliteIrhtGt100ft :{'&:after':{background: 'rgba(255,255,255, 0.298)'}},
  satelliteIrhtGt75ft  :{'&:after':{background: 'rgba(255,255,255, 0.231)'}},
  satelliteIrhtGt50ft  :{'&:after':{background: 'rgba(255,255,255, 0.169)'}},
  satelliteIrhtGt25ft  :{'&:after':{background: 'rgba(255,255,255, 0.114)'}},
  satelliteIrhtGt0ft   :{'&:after':{background: 'rgba(255,255,255, 0.051)'}},

  satelliteIrtpColorLtM69: {'&:after':{background: 'rgba(0, 0, 0,       0.6)'}},
  satelliteIrtpColorLtM61: {'&:after':{background: 'rgba(212, 0, 0,     0.6)'}},
  satelliteIrtpColorLtM53: {'&:after':{background: 'rgba(223, 102, 102, 0.6)'}},
  satelliteIrtpColorLtM44: {'&:after':{background: 'rgba(255, 255, 0,   0.6)'}},
  satelliteIrtpColorLtM36: {'&:after':{background: 'rgba(193, 210, 87,  0.6)'}},
  satelliteIrtpColorLtM26: {'&:after':{background: 'rgba(255, 255, 255, 0.53)'}},
  satelliteIrtpColorLtM17: {'&:after':{background: 'rgba(255, 255, 255, 0.4)'}},
  satelliteIrtpColorLtM13: {'&:after':{background: 'rgba(255, 255, 255, 0.27)'}},
  satelliteIrtpColorLtM8: {'&:after':{background:  'rgba(255, 255, 255, 0.23)'}},
  satelliteIrtpColorLtM4: {'&:after':{background:  'rgba(255, 255, 255, 0.2)'}},
  satelliteIrtpColorLt0: {'&:after':{background:   'rgba(255, 255, 255, 0.16)'}},
  satelliteIrtpColorLt5: {'&:after':{background:   'rgba(255, 255, 255, 0.13)'}},
  satelliteIrtpColorLt9: {'&:after':{background:   'rgba(255, 255, 255, 0.1)'}},
  satelliteIrtpColorLt14: {'&:after':{background:  'rgba(255, 255, 255, 0.07)'}},
  satelliteIrtpColorLt18: {'&:after':{background:  'rgba(255, 255, 255, 0.03)'}},
  satelliteIrtpColorGte18: {'&:after':{background: 'rgba(255, 255, 255, 0)'}},

  satelliteIrtpLtM69: {'&:after':{background: 'rgba(255,255,255, 0.99)'}},
  satelliteIrtpLtM61: {'&:after':{background: 'rgba(255,255,255, 0.976)'}},
  satelliteIrtpLtM53: {'&:after':{background: 'rgba(255,255,255, 0.976)'}},
  satelliteIrtpLtM44: {'&:after':{background: 'rgba(255,255,255, 0.812)'}},
  satelliteIrtpLtM36: {'&:after':{background: 'rgba(255,255,255, 0.706)'}},
  satelliteIrtpLtM26: {'&:after':{background: 'rgba(255,255,255, 0.616)'}},
  satelliteIrtpLtM17: {'&:after':{background: 'rgba(255,255,255, 0.502)'}},
  satelliteIrtpLtM13: {'&:after':{background: 'rgba(255,255,255, 0.4)'}},
  satelliteIrtpLtM8: {'&:after':{background:  'rgba(255,255,255, 0.275)'}},
  satelliteIrtpLtM4: {'&:after':{background:  'rgba(255,255,255, 0.173)'}},
  satelliteIrtpLt0: {'&:after':{background:   'rgba(255,255,255, 0.11)'}},
  satelliteIrtpLt5: {'&:after':{background:   'rgba(255,255,255, 0.059)'}},
  satelliteIrtpLt9: {'&:after':{background:   'rgba(255,255,255, 0.008)'}},
  satelliteIrtpLt14: {'&:after':{background:  'rgba(255,255,255, 0)'}},
  satelliteIrtpLt18: {'&:after':{background:  'rgba(255,255,255, 0)'}},
  satelliteIrtpGte18: {'&:after':{background: 'rgba(255,255,255, 0)'}}
}));

function LegendSatellite({contents: satellite}) {
  const classes = useStyles();
  const {mapColor, isDarkMap, changeMapColorDark, changeMapColorLight} = useMapColorState();
  const [dataType, setDataType] = useState(satellite.getDataType());

  const timeInfo = useRecoilValue(weatherTimeWithID(WX_ID_SATELLITE));

  const handleDataTypeChange = useCallback(event => {
    satellite.setDataType(event.target.value);
    setDataType(event.target.value);
  }, [satellite]);

  const handleMapColor = useCallback(event => {
    if (event.target.checked) {
      changeMapColorDark();
    } else {
      changeMapColorLight();
    }
  }, [changeMapColorDark, changeMapColorLight]);

  return (
    <div className={mapColor}>
      <div className="legend-contents-time">
        {timeInfo.baseTime}
      </div>
      <div>
        <RadioGroup row aria-label="position" name="rdo-data-type" value={dataType}>
          <FormControlLabel value={SATELLITE_TYPE_IRHT_COLOR} control={<Radio color="primary" size="small"/>} label={<span className={classes.inputLabel}>IRHT(Color)</span>} onChange={handleDataTypeChange}/>
          <FormControlLabel value={SATELLITE_TYPE_IRHT} control={<Radio color="primary" size="small"/>} label={<span className={classes.inputLabel}>IRHT</span>} onChange={handleDataTypeChange}/>
          <FormControlLabel value={SATELLITE_TYPE_WV} control={<Radio color="primary" size="small"/>} label={<span className={classes.inputLabel}>WV</span>} onChange={handleDataTypeChange}/>
          <FormControlLabel value={SATELLITE_TYPE_IRTP_COLOR} control={<Radio color="primary" size="small"/>} label={<span className={classes.inputLabel}>IRTP(Color)</span>} onChange={handleDataTypeChange}/>
          <FormControlLabel value={SATELLITE_TYPE_IRTP} control={<Radio color="primary" size="small"/>} label={<span className={classes.inputLabel}>IRTP</span>} onChange={handleDataTypeChange}/>
        </RadioGroup>
      </div>
      {
        (dataType === SATELLITE_TYPE_IRHT || dataType === SATELLITE_TYPE_WV || dataType === SATELLITE_TYPE_IRTP) &&
          <FormControlLabel
            control={<Switch checked={isDarkMap} onChange={handleMapColor} name="MAP_COLOR" size="small"/>}
            label={<span className={classes.inputLabel}>Map Dark</span>}
          />
      }
      <LegendIrhtColor dataType={dataType}/>
      <LegendIrht dataType={dataType}/>
      <LegendIrtpColor dataType={dataType}/>
      <LegendIrtp dataType={dataType}/>
    </div>
  )
}
function LegendIrhtColor({dataType}) {
  const classes = useStyles();
  return (
    <div hidden={dataType !== SATELLITE_TYPE_IRHT_COLOR}>
      <ul className={classes.satelliteLegend}>
        <li className={"tone " + classes.satelliteIrhtColorGt450ft}><span className="tone-separator">&gt;</span><span className="tone-val">45000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtColorGt400ft}><span className="tone-separator">&gt;</span><span className="tone-val">40000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtColorGt350ft}><span className="tone-separator">&gt;</span><span className="tone-val">35000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtColorGt300ft}><span className="tone-separator">&gt;</span><span className="tone-val">30000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtColorGt200ft}><span className="tone-separator">&gt;</span><span className="tone-val">20000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtColorGt100ft}><span className="tone-separator">&gt;</span><span className="tone-val">10000ft</span></li>
      </ul>
    </div>
  );
}
function LegendIrht({dataType}) {
  const classes = useStyles();
  return (
    <div hidden={dataType !== SATELLITE_TYPE_IRHT}>
      <ul className={classes.satelliteLegend}>
        <li className={"tone " + classes.satelliteIrhtGt500ft}><span className="tone-separator">&gt;</span><span className="tone-val">50000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt450ft}><span className="tone-separator">&gt;</span><span className="tone-val">45000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt400ft}><span className="tone-separator">&gt;</span><span className="tone-val">40000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt350ft}><span className="tone-separator">&gt;</span><span className="tone-val">35000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt300ft}><span className="tone-separator">&gt;</span><span className="tone-val">30000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt250ft}><span className="tone-separator">&gt;</span><span className="tone-val">25000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt200ft}><span className="tone-separator">&gt;</span><span className="tone-val">20000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt175ft}><span className="tone-separator">&gt;</span><span className="tone-val">17500ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt150ft}><span className="tone-separator">&gt;</span><span className="tone-val">15000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt125ft}><span className="tone-separator">&gt;</span><span className="tone-val">12500ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt100ft}><span className="tone-separator">&gt;</span><span className="tone-val">10000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt75ft}><span className="tone-separator">&gt;</span><span className="tone-val">7500ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt50ft}><span className="tone-separator">&gt;</span><span className="tone-val">5000ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt25ft}><span className="tone-separator">&gt;</span><span className="tone-val">2500ft</span></li>
        <li className={"tone " + classes.satelliteIrhtGt0ft}><span className="tone-separator">&gt;</span><span className="tone-val">0ft</span></li>
      </ul>
    </div>
  );
}

function LegendIrtpColor({dataType}) {
  const classes = useStyles();
  return (
    <div hidden={dataType !== SATELLITE_TYPE_IRTP_COLOR}>
      <ul className={classes.satelliteLegend}>
        <li className={"tone " + classes.satelliteIrtpColorLtM69}><span className="tone-separator">&lt;</span><span className="tone-val">-69℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLtM61}><span className="tone-separator">&lt;</span><span className="tone-val">-61℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLtM53}><span className="tone-separator">&lt;</span><span className="tone-val">-53℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLtM44}><span className="tone-separator">&lt;</span><span className="tone-val">-44℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLtM36}><span className="tone-separator">&lt;</span><span className="tone-val">-36℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLtM26}><span className="tone-separator">&lt;</span><span className="tone-val">-26℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLtM17}><span className="tone-separator">&lt;</span><span className="tone-val">-17℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLtM13}><span className="tone-separator">&lt;</span><span className="tone-val">-13℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLtM8}><span className="tone-separator">&lt;</span><span className="tone-val">-8℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLtM4}><span className="tone-separator">&lt;</span><span className="tone-val">-4℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLt0}><span className="tone-separator">&lt;</span><span className="tone-val">0℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLt5}><span className="tone-separator">&lt;</span><span className="tone-val">5℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLt9}><span className="tone-separator">&lt;</span><span className="tone-val">9℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLt14}><span className="tone-separator">&lt;</span><span className="tone-val">14℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorLt18}><span className="tone-separator">&lt;</span><span className="tone-val">18℃</span></li>
        <li className={"tone " + classes.satelliteIrtpColorGte18}><span className="tone-separator">&gt;=</span><span className="tone-val">18℃</span></li>
      </ul>
    </div>
  );
}

function LegendIrtp({dataType}) {
  const classes = useStyles();
  return (
    <div hidden={dataType !== SATELLITE_TYPE_IRTP}>
      <ul className={classes.satelliteLegend}>
        <li className={"tone " + classes.satelliteIrtpLtM69}><span className="tone-separator">&lt;</span><span className="tone-val">-69℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLtM61}><span className="tone-separator">&lt;</span><span className="tone-val">-61℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLtM53}><span className="tone-separator">&lt;</span><span className="tone-val">-53℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLtM44}><span className="tone-separator">&lt;</span><span className="tone-val">-44℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLtM36}><span className="tone-separator">&lt;</span><span className="tone-val">-36℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLtM26}><span className="tone-separator">&lt;</span><span className="tone-val">-26℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLtM17}><span className="tone-separator">&lt;</span><span className="tone-val">-17℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLtM13}><span className="tone-separator">&lt;</span><span className="tone-val">-13℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLtM8}><span className="tone-separator">&lt;</span><span className="tone-val">-8℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLtM4}><span className="tone-separator">&lt;</span><span className="tone-val">-4℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLt0}><span className="tone-separator">&lt;</span><span className="tone-val">0℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLt5}><span className="tone-separator">&lt;</span><span className="tone-val">5℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLt9}><span className="tone-separator">&lt;</span><span className="tone-val">9℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLt14}><span className="tone-separator">&lt;</span><span className="tone-val">14℃</span></li>
        <li className={"tone " + classes.satelliteIrtpLt18}><span className="tone-separator">&lt;</span><span className="tone-val">18℃</span></li>
        <li className={"tone " + classes.satelliteIrtpGte18}><span className="tone-separator">&gt;=</span><span className="tone-val">18℃</span></li>
      </ul>
    </div>
  );
}

export default LegendSatellite;